// Trigger creation is a typed request, never a free-text repair instruction.
export const TRIGGER_BUILD_RECIPES = Object.freeze({
  CREATE: Object.freeze({ flawSlug: 'POLLING_TRIGGER_CREATE', name: 'New records', description: 'Build a polling trigger for newly created records using the bound published read action.' }),
  UPDATE: Object.freeze({ flawSlug: 'POLLING_TRIGGER_UPDATE', name: 'Updated records', description: 'Build a polling trigger for updated records using the bound published read action and its update timestamp.' })
});

export const TRIGGER_BUILD_SLUGS = Object.freeze(Object.values(TRIGGER_BUILD_RECIPES).map((recipe) => recipe.flawSlug));
